import { render, staticRenderFns } from "./DisconnectFacebookAccount.vue?vue&type=template&id=11e228e2&lang=pug"
import script from "./DisconnectFacebookAccount.vue?vue&type=script&lang=js"
export * from "./DisconnectFacebookAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports